import React from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Link from '@atlaskit/link';
import { Stack, Text } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';

export const UpgradePlanContent = () => {
	const { formatMessage } = useIntl();

	const handleLinkClick = (_: React.MouseEvent, analyticEvent: UIAnalyticsEvent) => {
		// https://data-portal.internal.atlassian.com/analytics/registry/71212
		fireUIAnalytics(analyticEvent, 'featureTilePaymentPopoverCta');
	};

	return (
		<Stack space="space.100">
			<Text>{formatMessage(messages.description)}</Text>
			<Link
				href="/admin/billing/applications/change-edition/jira-servicedesk.ondemand"
				target="_blank"
				onClick={handleLinkClick}
				onMouseDown={(e) => {
					e.preventDefault();
				}}
			>
				{formatMessage(messages.ctaLink)}
			</Link>
		</Stack>
	);
};
